/**
 * Webhooks Sagas
 * Migrated from src/redux/apps/sagas/webhooks.js — ENG-35035
 *
 * Functions: TRIGGERS_LIST, TRIGGERS_LIST_NEW, WEBHOOKS_LIST, WEBHOOKS_LIST_NEW, GET_WEBHOOK, GET_WEBHOOK_NEW, ADD_WEBHOOK, ADD_WEBHOOK_NEW, UPDATE_WEBHOOK, UPDATE_WEBHOOK_NEW, DELETE_WEBHOOK, DELETE_WEBHOOK_NEW, CHANGE_WEBHOOK_STATUS, CHANGE_WEBHOOK_STATUS_NEW
 */

import { put, call, all, takeEvery } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import { push } from 'react-router-redux'
import { message } from 'antd'
import {
  list as webhooksList,
  get as webhookGet,
  add as webhookAdd,
  update as webhookUpdate,
  del as webhookDelete,
  getTriggersByID as webhookTriggersGet,
  addTriggers,
  delTriggers,
} from 'services/webhooks'
import {
  list as newWebhooksList,
  get as newWebhookGet,
  add as newWebhookAdd,
  update as newWebhookUpdate,
  del as newWebhookDelete,
  getTriggersByID as newWebhookTriggersGet,
  newAddTriggers,
  newDelTriggers,
} from 'services/webhooksNew'
import { list as triggersList, listNew as newTriggersList } from 'services/triggers'
import _ from 'lodash'
import { getAppHost } from 'helpers'
import actions from './actions'

export function* TRIGGERS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const success = yield call(
      triggersList,
      payload.data,
      getAppHost(payload.appSettings),
      payload.currentPage,
    )

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          triggersList: success.data,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          triggersList: [],
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* TRIGGERS_LIST_NEW({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const success = yield call(
      newTriggersList,
      payload.data,
      getAppHost(payload.appSettings),
      payload.currentPage,
    )

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          newTriggersList: success.data,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          newTriggersList: [],
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* WEBHOOKS_LIST({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areWebhooksLegacyLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const searchText = reduxStore.getState().webhooks.webhookSearchText

    const webhooksPagination = reduxStore.getState().webhooks.webhooksListPagination

    let pageNo = payload.currentPage
    if (pageNo === undefined && webhooksPagination.current_page !== undefined)
      pageNo = webhooksPagination.current_page + 1

    const success = yield call(
      webhooksList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
    )

    if (success && success.data) {
      let totalWebhookCount = success.data.length
      let webhooksListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalWebhookCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        webhooksListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          webhooksList: success.data,
          webhooksListTotal: totalWebhookCount,
          webhooksListPagination,
          areWebhooksLegacyLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          webhooksList: [],
          webhooksListTotal: 0,
          webhooksListPagination: [],
          areWebhooksLegacyLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areWebhooksLegacyLoading: false,
      },
    })
  }
}

export function* WEBHOOKS_LIST_NEW({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areWebhooksLoading: true,
      },
    })
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const searchText = reduxStore.getState().webhooks.webhookSearchText

    const newWebhooksPagination = reduxStore.getState().webhooks.newWebhooksListPagination
    let pageNo = payload.currentPage
    if (pageNo === undefined && newWebhooksPagination.current_page !== undefined)
      pageNo = newWebhooksPagination.current_page + 1

    const success = yield call(
      newWebhooksList,
      payload.data,
      getAppHost(payload.appSettings),
      pageNo,
      searchText,
    )
    if (success && success.data) {
      let totalWebhookCount = success.data.length
      let newWebhooksListPagination = []
      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalWebhookCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
        newWebhooksListPagination = success.meta.pagination
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          active: payload.data,
          newWebhooksList: success.data,
          newWebhooksListTotal: totalWebhookCount,
          newWebhooksListPagination,
          areWebhooksLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          newWebhooksList: [],
          newWebhooksListTotal: 0,
          newWebhooksListPagination: [],
          areWebhooksLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        areWebhooksLoading: false,
      },
    })
  }
}

export function* GET_WEBHOOK({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })

    const { id } = payload

    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(webhookGet, id, payload.data, getAppHost(payload.appSettings))
    if (success && success.data) {
      const triggersSuccess = yield call(
        webhookTriggersGet,
        id,
        payload.data,
        getAppHost(payload.appSettings),
      )

      const responseData = success.data
      responseData.triggers = triggersSuccess.data

      yield put({
        type: actions.SET_STATE,
        payload: {
          webhooksActive: success.data,
        },
      })
    } else {
      yield put(push(`/app/${payload.data.id}/webhooks-legacy`))
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* GET_WEBHOOK_NEW({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })

    const { id } = payload
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

    const success = yield call(newWebhookGet, id, payload.data, getAppHost(payload.appSettings))
    if (success && success.data) {
      const triggersSuccess = yield call(
        newWebhookTriggersGet,
        id,
        payload.data,
        getAppHost(payload.appSettings),
      )

      const responseData = success.data
      responseData.triggers = triggersSuccess.data

      yield put({
        type: actions.SET_STATE,
        payload: {
          newWebhooksActive: success.data,
        },
      })
    } else {
      yield put(push(`/app/${payload.data.id}/webhooks`))
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* ADD_WEBHOOK({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
    payload.name = payload.id
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(webhookAdd, payload, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      if (payload.triggers && payload.triggers.length)
        yield call(addTriggers, payload.id, payload.triggers, activeApp, getAppHost(appSettings))

      yield put({
        type: actions.WEBHOOKS_LIST,
        payload: { currentPage: 1, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/webhooks-legacy`))
      window.triggerNotification('Webhook added', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {},
      })
      if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
        window.triggerNotification('Plan restriction - Feature not available', 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* ADD_WEBHOOK_NEW({ payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
    payload.name = payload.id
    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const success = yield call(newWebhookAdd, payload, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      if (payload.triggers && payload.triggers.length)
        yield call(newAddTriggers, payload.id, payload.triggers, activeApp, getAppHost(appSettings))

      yield put({
        type: actions.WEBHOOKS_LIST_NEW,
        payload: { currentPage: 1, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/webhooks`))
      window.triggerNotification('Webhook added', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {},
      })
      if (success.error && success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
        window.triggerNotification('Plan restriction - Feature not available', 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Some error occurred', 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* UPDATE_WEBHOOK({ id, payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { webhooksActive } = reduxStore.getState().webhooks

    const filtered = {}
    const unset = []
    _.filter(payload, function fn(n, k) {
      if (k === 'useBasicAuth' || k === 'enabled' || (payload[k] && _.trim(payload[k]) !== '')) {
        filtered[k] = n
      } else {
        unset.push(k)
      }
    })

    filtered.unset = unset
    delete filtered.triggers
    const success = yield call(webhookUpdate, id, filtered, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const currentTriggers = []
      _.forEach(webhooksActive.triggers, function fn(ct) {
        currentTriggers.push(ct.id)
      })

      if (currentTriggers.length) {
        const removedTriggers = _.difference(currentTriggers, payload.triggers)

        if (removedTriggers.length) {
          yield call(delTriggers, payload.id, removedTriggers, activeApp, getAppHost(appSettings))
        }
      }

      if (_.uniq(payload.triggers) && _.uniq(payload.triggers).length) {
        let addTriggersCheck = false
        if (!webhooksActive.triggers.length) {
          addTriggersCheck = true
        } else {
          const checkIfNewTriggersSelected = _.xor(currentTriggers, _.uniq(payload.triggers))
          if (checkIfNewTriggersSelected.length) {
            addTriggersCheck = true
          }
        }
        if (addTriggersCheck) {
          const triggersToAdd = _.uniq(payload.triggers)
          yield call(addTriggers, payload.id, triggersToAdd, activeApp, getAppHost(appSettings))
        }
      }

      yield put({
        type: actions.GET_WEBHOOK,
        payload: {
          id: payload.id,
        },
      })

      yield put({
        type: actions.WEBHOOKS_LIST,
        payload: { currentPage: 1, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/webhooks-legacy`))
      window.triggerNotification('Webhook saved', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {},
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
        window.triggerNotification('Plan restriction - Feature not available', 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Uknown Error', 'error')
      }
    }

    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
    return undefined
  }
}

export function* UPDATE_WEBHOOK_NEW({ id, payload }) {
  try {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { newWebhooksActive } = reduxStore.getState().webhooks

    const filtered = {}
    const unset = []
    _.filter(payload, function fn(n, k) {
      if (
        k === 'useBasicAuth' ||
        k === 'enabled' ||
        k === 'retryOnFailure' ||
        (payload[k] && _.trim(payload[k]) !== '')
      ) {
        filtered[k] = n
      } else {
        unset.push(k)
      }
    })

    filtered.unset = unset
    delete filtered.triggers
    const success = yield call(newWebhookUpdate, id, filtered, activeApp, getAppHost(appSettings))
    if (success && success.data) {
      const currentTriggers = []
      _.forEach(newWebhooksActive.triggers, function fn(ct) {
        currentTriggers.push(ct.id)
      })

      if (currentTriggers.length) {
        const removedTriggers = _.difference(currentTriggers, payload.triggers)

        if (removedTriggers.length) {
          yield call(
            newDelTriggers,
            payload.id,
            removedTriggers,
            activeApp,
            getAppHost(appSettings),
          )
        }
      }

      if (_.uniq(payload.triggers) && _.uniq(payload.triggers).length) {
        let addTriggersCheck = false
        if (!newWebhooksActive.triggers.length) {
          addTriggersCheck = true
        } else {
          const checkIfNewTriggersSelected = _.xor(currentTriggers, _.uniq(payload.triggers))
          if (checkIfNewTriggersSelected.length) {
            addTriggersCheck = true
          }
        }
        if (addTriggersCheck) {
          const triggersToAdd = _.uniq(payload.triggers)
          yield call(
            newAddTriggers,
            payload.id,
            triggersToAdd,
            activeApp,
            getAppHost(appSettings),
          )
        }
      }

      yield put({
        type: actions.GET_WEBHOOK_NEW,
        payload: {
          id: payload.id,
        },
      })

      yield put({
        type: actions.WEBHOOKS_LIST_NEW,
        payload: { currentPage: 1, data: activeApp },
      })

      yield put(push(`/app/${activeApp.id}/webhooks`))
      window.triggerNotification('Webhook saved', 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {},
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        _.forEach(success.error.details, function fn(value) {
          message.error(value)
        })
      } else if (success.error.code === 'ERR_PLAN_RESTRICTION') {
        window.triggerNotification('Plan restriction - Feature not available', 'error')
      } else if (success.error.message !== undefined) {
        window.triggerNotification(success.error.message, 'error')
      } else {
        window.triggerNotification('Unknown Error', 'error')
      }
    }

    return success
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
    return undefined
  }
}

export function* DELETE_WEBHOOK({ payload }) {
  try {
    const { id, refresh } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { webhooksListPagination } = reduxStore.getState().webhooks

    yield put({
      type: actions.SET_STATE,
      payload: {},
    })

    const success = yield call(webhookDelete, id, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const webhookListPageNo =
        webhooksListPagination !== undefined && webhooksListPagination.count > 1
          ? webhooksListPagination.current_page
          : 1
      yield put({
        type: actions.WEBHOOKS_LIST,
        payload: { currentPage: webhookListPageNo, data: activeApp },
      })
      window.triggerNotification('Webhook deleted', 'success')

      if (refresh) yield put(push(`/app/${activeApp.id}/webhooks-legacy`))
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {},
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* DELETE_WEBHOOK_NEW({ payload }) {
  try {
    const { id, refresh } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps
    const { newWebhooksListPagination } = reduxStore.getState().webhooks

    yield put({
      type: actions.SET_STATE,
      payload: {},
    })

    const success = yield call(newWebhookDelete, id, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const webhookListPageNo =
        newWebhooksListPagination !== undefined && newWebhooksListPagination.count > 1
          ? newWebhooksListPagination.current_page
          : 1
      yield put({
        type: actions.WEBHOOKS_LIST_NEW,
        payload: { currentPage: webhookListPageNo, data: activeApp },
      })
      window.triggerNotification('Webhook deleted', 'success')

      if (refresh) yield put(push(`/app/${activeApp.id}/webhooks`))
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {},
      })
      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* CHANGE_WEBHOOK_STATUS({ payload }) {
  try {
    const { id, status } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const allWebhooks = reduxStore.getState().webhooks.webhooksList

    yield put({
      type: actions.SET_STATE,
      payload: {},
    })

    const data = { enabled: !status }

    const success = yield call(webhookUpdate, id, data, activeApp, getAppHost(appSettings))

    let successMessage

    if (success && success.data) {
      _.forEach(allWebhooks, function fn(c, k) {
        if (c.id === id) {
          if (allWebhooks[k].enabled) {
            successMessage = 'disabled'
          } else {
            successMessage = 'enabled'
          }

          allWebhooks[k].enabled = !allWebhooks[k].enabled
        }
      })

      yield put({
        type: actions.SET_STATE,
        payload: {
          webhooksList: allWebhooks,
        },
      })
      window.triggerNotification(`Webhook ${successMessage}`, 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {},
      })

      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export function* CHANGE_WEBHOOK_STATUS_NEW({ payload }) {
  try {
    const { id, status } = payload

    const activeApp = reduxStore.getState().apps.active
    const { appSettings } = reduxStore.getState().apps

    const allWebhooks = reduxStore.getState().webhooks.newWebhooksList

    yield put({
      type: actions.SET_STATE,
      payload: {},
    })

    const data = { enabled: !status }

    const success = yield call(newWebhookUpdate, id, data, activeApp, getAppHost(appSettings))

    let successMessage

    if (success && success.data) {
      _.forEach(allWebhooks, function fn(c, k) {
        if (c.id === id) {
          if (allWebhooks[k].enabled) {
            successMessage = 'disabled'
          } else {
            successMessage = 'enabled'
          }

          allWebhooks[k].enabled = !allWebhooks[k].enabled
        }
      })

      yield put({
        type: actions.SET_STATE,
        payload: {
          newWebhooksList: allWebhooks,
        },
      })
      window.triggerNotification(`Webhook ${successMessage}`, 'success')
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {},
      })

      if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {},
    })
  }
}

export default function* webhooksSaga() {
  yield all([
    takeEvery(actions.TRIGGERS_LIST, TRIGGERS_LIST),
    takeEvery(actions.TRIGGERS_LIST_NEW, TRIGGERS_LIST_NEW),
    takeEvery(actions.WEBHOOKS_LIST, WEBHOOKS_LIST),
    takeEvery(actions.WEBHOOKS_LIST_NEW, WEBHOOKS_LIST_NEW),
    takeEvery(actions.GET_WEBHOOK, GET_WEBHOOK),
    takeEvery(actions.GET_WEBHOOK_NEW, GET_WEBHOOK_NEW),
    takeEvery(actions.ADD_WEBHOOK, ADD_WEBHOOK),
    takeEvery(actions.ADD_WEBHOOK_NEW, ADD_WEBHOOK_NEW),
    takeEvery(actions.UPDATE_WEBHOOK, UPDATE_WEBHOOK),
    takeEvery(actions.UPDATE_WEBHOOK_NEW, UPDATE_WEBHOOK_NEW),
    takeEvery(actions.DELETE_WEBHOOK, DELETE_WEBHOOK),
    takeEvery(actions.DELETE_WEBHOOK_NEW, DELETE_WEBHOOK_NEW),
    takeEvery(actions.CHANGE_WEBHOOK_STATUS, CHANGE_WEBHOOK_STATUS),
    takeEvery(actions.CHANGE_WEBHOOK_STATUS_NEW, CHANGE_WEBHOOK_STATUS_NEW),
  ])
}
